import { useEffect, useRef, useState } from "react"
import { Helmet } from "react-helmet"
import { useNavigate } from "react-router-dom"
import { toast, ToastContainer } from "react-toastify"
import Banner1 from "../../assets/nossosservicos/banner-1.png"
import column1 from "../../assets/nossosservicos/Colum1teste.png"
import column2 from "../../assets/nossosservicos/colum2.png"
import column3 from "../../assets/nossosservicos/Colum3teste.png"
import Banner2 from "../../assets/nossosservicos/fundo2nossoservicos.png"
import item1 from "../../assets/nossosservicos/item1.png"
import item2 from "../../assets/nossosservicos/item2.png"
import item3 from "../../assets/nossosservicos/item3.png"
import item4 from "../../assets/nossosservicos/item4.png"
import item5 from "../../assets/nossosservicos/item5.png"
import banner from "../../assets/nossosservicos/NewSteelTech.png"
import Footer from "../../components/footer/Footer"
import Header from "../../components/header/Header"
import EmailService from "../../services/EmailService"
import ScrollToTopButton from "../home/components/ScrollToTopButton"
export default function ServicesScreen() {
    useEffect(() => {
        document.title = "Logplace - Nossos Serviços"
    }, [])
    const mainRef = useRef<HTMLDivElement>(null)

    const [headerFixed, setHeaderFixed] = useState(false)
    const [isVisible, setIsVisible] = useState(false)

    const [formData, setFormData] = useState({
        nomeEmpresa: "",
        cnpj: "",
        email: "",
        telefone: "",
        ramoAtividade: "",
        outrasInformacoes: ""
    })

    const navigate = useNavigate()

    const validate = () => {
        let newErrors: any = {}
        if (!formData.nomeEmpresa) {
            toast.error("Nome da Empresa é obrigatório", {
                style: {
                    backgroundColor: "#f44336",
                    color: "#fff",
                    padding: "16px",
                    borderRadius: "10px",
                    border: "2px solid #D32F2F",
                    fontSize: "16px"
                }
            })
            return false
        }
        if (!formData.cnpj) {
            toast.error("CNPJ é obrigatório", {
                style: {
                    backgroundColor: "#f44336",
                    color: "#fff",
                    padding: "16px",
                    borderRadius: "10px",
                    border: "2px solid #D32F2F",
                    fontSize: "16px"
                }
            })
            return false
        }
        if (!formData.email) {
            toast.error("Email é obrigatório", {
                style: {
                    backgroundColor: "#f44336",
                    color: "#fff",
                    padding: "16px",
                    borderRadius: "10px",
                    border: "2px solid #D32F2F",
                    fontSize: "16px"
                }
            })
            return false
        }
        if (!formData.telefone) {
            toast.error("Telefone é obrigatório", {
                style: {
                    backgroundColor: "#f44336",
                    color: "#fff",
                    padding: "16px",
                    borderRadius: "10px",
                    border: "2px solid #D32F2F",
                    fontSize: "16px"
                }
            })
            return false
        }
        return true
    }

    const handleChange = (e: any) => {
        const { name, value } = e.target
        setFormData({
            ...formData,
            [name]: value
        })
    }

    const handleSubmit = async (e: any) => {
        e.preventDefault()

        const validationErrors = validate()
        if (!validationErrors) {
            return
        }
        const stringToSend =
            formData.nomeEmpresa +
            ";" +
            formData.cnpj +
            ";" +
            formData.email +
            ";" +
            formData.telefone +
            ";" +
            formData.ramoAtividade +
            ";" +
            formData.outrasInformacoes
        await EmailService.sendEmail(
            "Contato de empresa",
            stringToSend,
            "cotacao",
            null
        )
            .then((response) => {
                toast.success("Email enviado com sucesso", {
                    style: {
                        backgroundColor: "#4CAF50",
                        color: "#fff",
                        padding: "16px",
                        borderRadius: "10px",
                        border: "2px solid #4CAF50",
                        fontSize: "16px"
                    }
                })
            })

            .catch((error) => {
                toast.error("Erro ao enviar email", {
                    style: {
                        backgroundColor: "#f44336",
                        color: "#fff",
                        padding: "16px",
                        borderRadius: "10px",
                        border: "2px solid #D32F2F",
                        fontSize: "16px"
                    }
                })
            })
    }

    const headerFixedTrue = () => {
        setHeaderFixed(true)
    }

    const headerFixedFalse = () => {
        setHeaderFixed(false)
    }

    const scrollToTop = () => {
        if (mainRef.current) {
            mainRef.current.scrollTo({ top: 0, behavior: "smooth" })
        }
    }

    return (
        <>
            <Helmet>
                <title>Nossos Serviços</title>
                <meta
                    name="description"
                    content="Oferecemos soluções logísticas sob medida para sua operação. Fulfillment, B2B, B2C com inteligência e tecnologia."
                />
                <meta
                    name="keywords"
                    content="logística, fulfillment, B2C, B2B, transporte, soluções logísticas, entregas, e-commerce"
                />
                <meta name="author" content="LogPlace" />
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1.0"
                />
                <meta property="og:title" content="Nossos Serviços" />
                <meta
                    property="og:description"
                    content="Somos líderes em soluções logísticas para o pequeno, médio e-commerce e grandes operações de varejo."
                />
                <meta property="og:url" content="https://logplace.com.br" />
                <meta property="og:type" content="website" />
            </Helmet>
            <ScrollToTopButton show={isVisible} scrollPage={scrollToTop} />
            <div
                ref={mainRef}
                className="relative flex flex-col flex-1 w-full h-screen overflow-auto bg-white xl:overflow-y-auto"
                onScroll={(event: any) => {
                    if (event.currentTarget.scrollTop > 10) {
                        setHeaderFixed(true)
                    } else {
                        setHeaderFixed(false)
                    }

                    if (event.currentTarget.scrollTop > 500) {
                        setIsVisible(true)
                    } else {
                        setIsVisible(false)
                    }
                }}
            >
                <div className="absolute inset-0 w-full bg-gradient-to-b from-white from-5% via-secondary-1 via-30% via-secondary-2 via-35% to-primary to-80% z-0">
                    <ToastContainer
                        position="bottom-left"
                        autoClose={1500}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        icon={false}
                        limit={1}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                    <div className="h-[7rem] bg-white">
                        <Header
                            background={headerFixed ? " " : ""}
                            headerFixedTrue={headerFixedTrue}
                            headerFixedFalse={headerFixedFalse}
                        />
                    </div>

                    <div className="relative h-[28rem] sm:h-[40rem] flex flex-col overflow-hidden">
                        <img
                            className="absolute top-0 right-0 w-full h-full object-cover object-top z-0 md:block"
                            src={Banner1}
                            alt="entregador"
                        />
                        <div className="z-20 p-2 sm:p-16 h-full flex flex-col justify-center space-y-2">
                            <p className="text-white sm:text-2xl font-bold">
                                O QUE FAZEMOS
                            </p>
                            <span className="w-max p-4 bg-white">
                                <p className="text-secondary-1 font-bold sm:text-2xl lg:text-4xl">
                                    OPERAÇÕES B2B E B2C.
                                </p>
                            </span>
                            <span className="w-max p-4 bg-white">
                                <p className="text-secondary-1 font-bold sm:text-2xl lg:text-4xl">
                                    OPERAÇÕES DE ALTO VALOR.
                                </p>
                            </span>
                            <span className="w-max p-4 bg-white">
                                <p className="text-secondary-1 font-bold sm:text-2xl lg:text-4xl">
                                    GERENCIAMENTO DA ENTREGA.
                                </p>
                            </span>
                        </div>
                    </div>
                    <div className="relative h-[90rem] sm:h-[22rem] md:h-[24rem] lg:h-[28rem] xl:h-[35rem] flex flex-col space-y-6 lg:space-y-10 bg-white justify-center items-center p-4">
                        <img
                            className="absolute top-0 right-0 w-full h-full object-cover object-top z-0 md:block"
                            src={Banner2}
                            alt="entregador"
                        />
                        <div className="z-20 flex h-full md:h-3/4 items-center flex-col sm:flex-row md:justify-evenly w-full">
                            <div className="w-max flex flex-col h-full md:h-2/3 items-center justify-center space-y-4 lg:space-y-6  p-2">
                                <div className="h-3/4 w-full flex items-end justify-center">
                                    <img src={item1} />
                                </div>
                                <div className="h-1/3 flex w-full md:w-max">
                                    <p className="font-bold text-start sm:text-sm md:text-base text-white">
                                        110.000 entregas/mês médio.
                                        <br />
                                        10.000 entregas/mês leve.
                                    </p>
                                </div>
                            </div>
                            <div className="w-max flex flex-col h-full md:h-2/3 items-center justify-center space-y-4 lg:space-y-6  p-2">
                                <div className="h-3/4 w-full flex items-end justify-center ">
                                    <img src={item2} />
                                </div>
                                <div className="h-1/3 flex w-full md:w-max">
                                    <p className="font-bold text-start sm:text-sm md:text-base text-white">
                                        1000+ <br /> Veículos na <br />
                                        operação.
                                    </p>
                                </div>
                            </div>
                            <div className="w-max flex flex-col h-full md:h-2/3 items-center justify-center space-y-4 lg:space-y-6  p-2">
                                <div className="h-3/4 w-full flex items-end justify-center">
                                    <img src={item3} />
                                </div>
                                <div className="h-1/3 flex w-full md:w-max">
                                    <p className="font-bold sm:text-sm md:text-base text-start text-white">
                                        Distribuição de <br /> acordo com o
                                        <br /> projeto logístico <br /> de cada
                                        cliente.
                                    </p>
                                </div>
                            </div>
                            <div className="w-max flex flex-col h-full md:h-2/3 items-center justify-center space-y-4 lg:space-y-6  p-2">
                                <div className="h-3/4 w-full flex items-end justify-center">
                                    <img src={item4} />
                                </div>
                                <div className="h-1/3 flex w-full md:w-max">
                                    <p className="font-bold sm:text-sm md:text-base text-start text-white">
                                        Distribuição em <br /> todo o Nordeste
                                        <br /> sem restrição de
                                        <br className="hidden md:block" /> CEP.
                                    </p>
                                </div>
                            </div>
                            <div className="w-max flex flex-col h-full md:h-2/3 items-center justify-center space-y-4 lg:space-y-6  p-2">
                                <div className="h-3/4 w-full flex items-end justify-center">
                                    <img src={item5} />
                                </div>
                                <div className="h-1/3 flex w-full md:w-max">
                                    <p className="font-bold sm:text-sm md:text-base text-start text-white">
                                        14 Unidades <br /> distribuídas em
                                        <br /> 11 Estados.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="h-[50rem] sm:h-[38rem] xl:h-[48rem] flex flex-col p-4 sm:p-14 lg:space-y-10 bg-white ">
                        <div className="w-max p-4">
                            <div>
                                <h1 className="text-lg sm:text-xl xl:text-3xl font-bold text-primary">
                                    NOSSOS SERVIÇOS
                                </h1>
                            </div>
                            <p className="text-xl sm:text-3xl xl:text-5xl font-bold text-gray-500">
                                Você tem a necessidade
                            </p>
                            <div className="flex flex-row text-xl sm:text-3xl xl:text-5xl font-bold space-x-2">
                                <p className="text-gray-500">Nós temos a</p>
                                <p className="text-primary">SOLUÇÃO.</p>
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row h-full relative">
                            <div className="hidden absolute w-full h-full sm:flex justify-center items-end">
                                <img
                                    className="object-cover md:w-1/3 xl:w-3/5 h-full z-20"
                                    src={column2}
                                />
                            </div>
                            <div className="w-full sm:w-1/3 h-full flex justify-center items-center flex-col z-10">
                                <div className="h-1/5">
                                    <p className="text-2xl md:text-3xl xl:text-5xl font-bold text-primary">
                                        Operações B2B.
                                    </p>
                                </div>
                                <div className="h-4/5">
                                    <img
                                        src={column1}
                                        className="object-contain w-full h-full z-10"
                                    />
                                </div>
                            </div>
                            <div className="hidden relative w-1/3 md:h-1/2 xl:h-full sm:flex items-end justify-end z-30"></div>
                            <div className="mt-10 sm:mt-0 w-full sm:w-1/3 h-full flex justify-center items-center flex-col z-10">
                                <div className="h-1/5">
                                    <p className="text-2xl md:text-3xl xl:text-5xl font-bold text-primary">
                                        Operações B2C.
                                    </p>
                                </div>
                                <div className="h-4/5">
                                    <img
                                        src={column3}
                                        className="object-contain w-full h-full z-10"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="hidden  md:h-[28rem] lg:h-[38rem] sm:flex flex-col bg-white justify-center items-center ">
                        <img
                            className="object-cover w-full h-full"
                            src={banner}
                            alt="entregador"
                        />
                    </div>
                    <div className="h-[75rem] sm:h-[49rem] md:h-[52rem] lg:h-[52rem] xl:h-[38rem] flex flex-col-reverse xl:flex-row bg-white lg:px-44 lg:py-8 xl:space-x-4 ">
                        <div className="flex w-full h-full p-2 xl:w-1/2 xl:p-0">
                            <div className="flex flex-col w-full h-full rounded-lg shadow-md bg-primary p-6">
                                <div className="flex items-center justify-center flex-1">
                                    <h1 className="text-2xl font-bold text-white">
                                        COMECE A OPERAR CONOSCO AGORA!
                                    </h1>
                                </div>
                                <form
                                    onSubmit={handleSubmit}
                                    className="flex flex-col justify-center w-full space-y-2 flex-5"
                                >
                                    <div className="flex flex-row w-full h-12 space-x-2">
                                        <input
                                            className="w-1/2 p-2 rounded-md"
                                            type="text"
                                            placeholder="Nome da Empresa"
                                            name="nomeEmpresa"
                                            value={formData.nomeEmpresa}
                                            onChange={handleChange}
                                        />
                                        <input
                                            className="w-1/2 p-2 rounded-md"
                                            type="text"
                                            placeholder="CNPJ"
                                            name="cnpj"
                                            value={formData.cnpj}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="flex flex-row w-full h-12 space-x-2">
                                        <input
                                            className="w-1/2 p-2 rounded-md"
                                            type="email"
                                            placeholder="Email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                        />
                                        <input
                                            className="w-1/2 p-2 rounded-md"
                                            type="tel"
                                            placeholder="DDD-Numero (WhatsApp)"
                                            name="telefone"
                                            value={formData.telefone}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="flex flex-row w-full h-12 space-x-2">
                                        <input
                                            className="w-full p-2 rounded-md"
                                            type="text"
                                            placeholder="Ramo de atividade da empresa"
                                            name="ramoAtividade"
                                            value={formData.ramoAtividade}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="flex flex-row w-full h-24 space-x-2">
                                        <textarea
                                            className="w-full p-2 rounded-md resize-none"
                                            placeholder="Outras informações"
                                            name="outrasInformacoes"
                                            value={formData.outrasInformacoes}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="w-full h-12 space-x-2">
                                        <button
                                            className="w-full h-full rounded-lg bg-secondary-1"
                                            type="submit"
                                        >
                                            <h1 className="font-bold text-white">
                                                QUERO OPERAR COM A LOGPLACE
                                            </h1>
                                        </button>
                                    </div>

                                    <div className="w-full h-12 space-x-2">
                                        <p className="text-xs text-center text-white">
                                            Conforme estabelecido na Lei LGPD
                                            3218/2019, o usuário autoriza a
                                            utilização dos dados fornecidos
                                            acima em processos internos da
                                            empresa.
                                        </p>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="flex flex-col items-center justify-center w-full h-full p-2 space-y-4 text-justify xl:w-1/2 xl:p-6">
                            <h1 className="text-2xl font-semibold text-center w-2/3">
                                Quer elevar sua operação logística ao próximo
                                nível?
                            </h1>
                            <p className="flex text-xl text-justify">
                                A LogPlace é especialista no transporte de
                                cargas de Alto Valor, sempre utilizando as
                                carretas SteelTech para máxima segurança. Com
                                mais de 18 anos de experiência no mercado, mais
                                de 1000 veículos em circulação e uma equipe
                                altamente qualificada, garantimos soluções
                                logísticas personalizadas, eficientes e seguras
                                em todo o Brasil.
                            </p>
                            <p className="text-xl w-full text-justify">
                                Preencha o formulário ao lado e descubra como
                                podemos otimizar sua operação. Seu sucesso
                                logístico começa aqui!
                            </p>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    )
}
